import PropTypes from 'prop-types';

export default function SectionCard({ children, title }) {
    return (
        <section className="exec-pulse-panel">
            {title ? (
                <h2 className="exec-pulse-panel__title">{title}</h2>
            ) : null}
            {children}
        </section>
    );
}

SectionCard.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string
};

SectionCard.defaultProps = {
    title: undefined
};
